// SimTaskStream: 시뮬레이터 타입 무관 태스크 스트림 릴레이 (BFF → 웹).
//
// 어댑터가 공용 계약(vsmr.stream.v1, stream/sim_stream.proto)으로 Kafka에
// 발행한 것을 sim-stream-demux가 redis로 릴레이하고, BFF가 이 서비스로 웹에
// 중계한다. 태스크 타입 고유 스트림(MARS MinorEdit)의 단건 RPC는
// mars_task_stream에 있고, 탭 단위 멀티플렉스(SubscribeSessionStream)는 이를
// 포함한 태스크 스트림 전부와 세션 이벤트를 봉투(kind)로 나른다.
//
// 브라우저는 SubscribeSessionStream(탭당 연결 1개)만 쓴다 — 브라우저 HTTP/1.1은
// origin당 동시 연결 6개 한도라, 태스크별×종류별 개별 스트림은 참가자 수에
// 비례해 한도를 넘는다(스트림 요청이 preflight 후 브라우저 큐에서 기아).
// 단건 RPC(SubscribeSimState 등)는 헤드리스 클라이언트·진단용으로 유지한다.

// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file stream/sim_task_stream.proto (package vsmr.stream.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * 스트림 종류 — payload 디코딩 타입을 결정한다. 새 타입 고유 스트림이
 * 생기면 여기에 kind를 추가한다 (payload는 불투명 릴레이라 계약 단절 없음).
 *
 * @generated from enum vsmr.stream.v1.SimStreamKind
 */
export enum SimStreamKind {
  /**
   * @generated from enum value: SIM_STREAM_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * payload = vsmr.stream.v1.SimState
   *
   * @generated from enum value: SIM_STREAM_KIND_SIMSTATE = 1;
   */
  SIMSTATE = 1,

  /**
   * payload = vsmr.stream.v1.ScreenLogLine
   *
   * @generated from enum value: SIM_STREAM_KIND_SCREENLOG = 2;
   */
  SCREENLOG = 2,

  /**
   * payload = vsmr.stream.v1.Telemetry
   *
   * @generated from enum value: SIM_STREAM_KIND_TELEMETRY = 3;
   */
  TELEMETRY = 3,

  /**
   * payload = vsmr.mars.v1.MinorEditSnapshot (MARS 고유)
   *
   * @generated from enum value: SIM_STREAM_KIND_MINOREDIT = 4;
   */
  MINOREDIT = 4,

  /**
   * 아래는 SubscribeSessionStream(탭 통합 스트림) 전용 제어 kind —
   * payload가 세션 식별자를 내장해 자기서술적이다.
   *
   * payload = vsmr.sm.v1.SessionEvent (seq 내장)
   *
   * @generated from enum value: SIM_STREAM_KIND_SESSION_EVENT = 5;
   */
  SESSION_EVENT = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(SimStreamKind)
proto3.util.setEnumType(SimStreamKind, "vsmr.stream.v1.SimStreamKind", [
  { no: 0, name: "SIM_STREAM_KIND_UNSPECIFIED" },
  { no: 1, name: "SIM_STREAM_KIND_SIMSTATE" },
  { no: 2, name: "SIM_STREAM_KIND_SCREENLOG" },
  { no: 3, name: "SIM_STREAM_KIND_TELEMETRY" },
  { no: 4, name: "SIM_STREAM_KIND_MINOREDIT" },
  { no: 5, name: "SIM_STREAM_KIND_SESSION_EVENT" },
]);

/**
 * @generated from message vsmr.stream.v1.SubscribeSessionStreamRequest
 */
export class SubscribeSessionStreamRequest extends Message<SubscribeSessionStreamRequest> {
  /**
   * session-event 재개 커서 — seq > events_after_seq 인 보존 이벤트를 재생
   * (SessionEventsRequest.after_seq 의미론 그대로; 0이면 보존분 전부)
   *
   * @generated from field: uint64 events_after_seq = 1;
   */
  eventsAfterSeq = protoInt64.zero;

  /**
   * 커서의 로그 세대 — 마지막으로 본 SessionEvent.log_epoch
   * (SessionEventsRequest.after_epoch 그대로 통과). SM 레플리카가 바뀌어
   * 세션 로그가 seq 1 부터 다시 시작했으면 SM 이 events_after_seq 를 무시하고
   * 보존분 전부를 재생한다. 0 = 세대 모름(종전 동작).
   *
   * @generated from field: uint64 events_after_epoch = 3;
   */
  eventsAfterEpoch = protoInt64.zero;

  /**
   * @generated from field: repeated vsmr.stream.v1.SubscribeSessionStreamRequest.SimSubscription sims = 2;
   */
  sims: SubscribeSessionStreamRequest_SimSubscription[] = [];

  constructor(data?: PartialMessage<SubscribeSessionStreamRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.stream.v1.SubscribeSessionStreamRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "events_after_seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "events_after_epoch", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "sims", kind: "message", T: SubscribeSessionStreamRequest_SimSubscription, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscribeSessionStreamRequest {
    return new SubscribeSessionStreamRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscribeSessionStreamRequest {
    return new SubscribeSessionStreamRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscribeSessionStreamRequest {
    return new SubscribeSessionStreamRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SubscribeSessionStreamRequest | PlainMessage<SubscribeSessionStreamRequest> | undefined, b: SubscribeSessionStreamRequest | PlainMessage<SubscribeSessionStreamRequest> | undefined): boolean {
    return proto3.util.equals(SubscribeSessionStreamRequest, a, b);
  }
}

/**
 * 태스크 프레임을 원하는 sim 집합 (빈 목록 = 세션 이벤트만 —
 * 실행을 보지 않는 동안 탭이 상시 쥐는 모양)
 *
 * @generated from message vsmr.stream.v1.SubscribeSessionStreamRequest.SimSubscription
 */
export class SubscribeSessionStreamRequest_SimSubscription extends Message<SubscribeSessionStreamRequest_SimSubscription> {
  /**
   * @generated from field: string sim_id = 1;
   */
  simId = "";

  /**
   * @generated from field: repeated string task_ids = 2;
   */
  taskIds: string[] = [];

  constructor(data?: PartialMessage<SubscribeSessionStreamRequest_SimSubscription>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.stream.v1.SubscribeSessionStreamRequest.SimSubscription";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sim_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "task_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscribeSessionStreamRequest_SimSubscription {
    return new SubscribeSessionStreamRequest_SimSubscription().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscribeSessionStreamRequest_SimSubscription {
    return new SubscribeSessionStreamRequest_SimSubscription().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscribeSessionStreamRequest_SimSubscription {
    return new SubscribeSessionStreamRequest_SimSubscription().fromJsonString(jsonString, options);
  }

  static equals(a: SubscribeSessionStreamRequest_SimSubscription | PlainMessage<SubscribeSessionStreamRequest_SimSubscription> | undefined, b: SubscribeSessionStreamRequest_SimSubscription | PlainMessage<SubscribeSessionStreamRequest_SimSubscription> | undefined): boolean {
    return proto3.util.equals(SubscribeSessionStreamRequest_SimSubscription, a, b);
  }
}

/**
 * @generated from message vsmr.stream.v1.GetRecentSimFramesRequest
 */
export class GetRecentSimFramesRequest extends Message<GetRecentSimFramesRequest> {
  /**
   * 라벨·로깅용 (스트림 선택은 task_ids가 결정)
   *
   * @generated from field: string sim_id = 1;
   */
  simId = "";

  /**
   * 조회할 태스크들
   *
   * @generated from field: repeated string task_ids = 2;
   */
  taskIds: string[] = [];

  /**
   * 되감을 창(초). 얼마나 볼지는 화면의 정책이므로 클라이언트가 정하고,
   * 서버는 상한으로만 클램프한다. 0/미지정이면 아무것도 돌려주지 않는다 —
   * 지정하지 않은 호출자에게 임의의 과거를 주지 않는다.
   *
   * @generated from field: double window_seconds = 3;
   */
  windowSeconds = 0;

  constructor(data?: PartialMessage<GetRecentSimFramesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.stream.v1.GetRecentSimFramesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sim_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "task_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "window_seconds", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetRecentSimFramesRequest {
    return new GetRecentSimFramesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetRecentSimFramesRequest {
    return new GetRecentSimFramesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetRecentSimFramesRequest {
    return new GetRecentSimFramesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetRecentSimFramesRequest | PlainMessage<GetRecentSimFramesRequest> | undefined, b: GetRecentSimFramesRequest | PlainMessage<GetRecentSimFramesRequest> | undefined): boolean {
    return proto3.util.equals(GetRecentSimFramesRequest, a, b);
  }
}

/**
 * @generated from message vsmr.stream.v1.RecentSimFrames
 */
export class RecentSimFrames extends Message<RecentSimFrames> {
  /**
   * 시각 오름차순 — 구독으로 이어 붙이기 좋게 정렬해 보낸다
   *
   * @generated from field: repeated vsmr.stream.v1.SimStreamEnvelope frames = 1;
   */
  frames: SimStreamEnvelope[] = [];

  /**
   * 서버가 창을 클램프했으면 실제로 적용된 값 (클라이언트가 알 수 있게)
   *
   * @generated from field: double applied_window_seconds = 2;
   */
  appliedWindowSeconds = 0;

  constructor(data?: PartialMessage<RecentSimFrames>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.stream.v1.RecentSimFrames";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "frames", kind: "message", T: SimStreamEnvelope, repeated: true },
    { no: 2, name: "applied_window_seconds", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RecentSimFrames {
    return new RecentSimFrames().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RecentSimFrames {
    return new RecentSimFrames().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RecentSimFrames {
    return new RecentSimFrames().fromJsonString(jsonString, options);
  }

  static equals(a: RecentSimFrames | PlainMessage<RecentSimFrames> | undefined, b: RecentSimFrames | PlainMessage<RecentSimFrames> | undefined): boolean {
    return proto3.util.equals(RecentSimFrames, a, b);
  }
}

/**
 * @generated from message vsmr.stream.v1.SimStreamEnvelope
 */
export class SimStreamEnvelope extends Message<SimStreamEnvelope> {
  /**
   * @generated from field: vsmr.stream.v1.SimStreamKind kind = 1;
   */
  kind = SimStreamKind.UNSPECIFIED;

  /**
   * kind별 계약 메시지의 직렬화 바이트 — task_id/task_type은 payload에 내장
   *
   * @generated from field: bytes payload = 2;
   */
  payload = new Uint8Array(0);

  constructor(data?: PartialMessage<SimStreamEnvelope>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "vsmr.stream.v1.SimStreamEnvelope";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(SimStreamKind) },
    { no: 2, name: "payload", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SimStreamEnvelope {
    return new SimStreamEnvelope().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SimStreamEnvelope {
    return new SimStreamEnvelope().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SimStreamEnvelope {
    return new SimStreamEnvelope().fromJsonString(jsonString, options);
  }

  static equals(a: SimStreamEnvelope | PlainMessage<SimStreamEnvelope> | undefined, b: SimStreamEnvelope | PlainMessage<SimStreamEnvelope> | undefined): boolean {
    return proto3.util.equals(SimStreamEnvelope, a, b);
  }
}

